<custom-modal-card class="program-schedule mat-dialog-transparent">
  <ng-container header>
    <default-modal-header
      title="Programme du programme"
      description="Gérez la programmation du programme grâce aux paramètres suivants"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form *ngIf="form" [formGroup]="form" class="resource-form">
      <ng-container formArrayName="broadcastPeriods">
        <ng-container
          *ngIf="currentPeriodControl && !currentPeriodControl.get('id')?.value"
        >
          <cron-editor
            [cron]="currentPeriodControl.get('value')?.value || ''"
            (cronChange)="currentPeriodControl.get('value')?.patchValue($event)"
            (dateChange)="currentPeriodControl.get('value')?.patchValue($event)"
          >
            <article>
              <mat-label>Durée (minutes): </mat-label>
              <mat-form-field>
                <div matPrefix class="custom-prefix">
                  <img src="assets/icons/calendar_grey.svg" alt="" />
                </div>
                <input
                  [formControl]="$any(currentPeriodControl.get('duration'))"
                  matInput
                  type="number"
                  placeholder="Entrez la durée du programme"
                  [min]="1"
                />

                <span matSuffix>mn</span>
              </mat-form-field>
            </article></cron-editor
          >
        </ng-container>

        <mat-chip-listbox>
          <mat-chip
            *ngFor="let periodForm of periodsControls!.controls; let i = index"
            class="program-schedule__chip"
            [class.program-schedule__chip--invalid]="
              !periodForm.get('value')?.value ||
              periodForm.get('duration')?.invalid
            "
          >
            {{
              $any(
                periodForm.get('value')?.value
                  | useFunction: formatDateExpression
              ) | toTitleCase
            }}, {{ periodForm.get('duration')?.value }}mn
            <button
              (click)="removeForm(i)"
              [disabled]="
                $any(
                  { id: periodForm.get('id')?.value, ids: loadingItemIds }
                    | useFunction: includes
                )
              "
              matChipRemove
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-listbox>
      </ng-container>
    </form>
  </ng-container>

  <footer footer class="resource-form">
    <div class="program-schedule__actions">
      <button
        (click)="addSchedule()"
        [disabled]="!form?.valid || isLoading"
        class="btn btn--primary-light"
      >
        Ajouter
      </button>
      <button
        (click)="saveProgram()"
        [attr.loading]="isLoading"
        [disabled]="
          !currentPeriodControl ||
          currentPeriodControl.value.id ||
          !form?.valid ||
          isLoading
        "
        [class.square-btn--red]="
          !currentPeriodControl || currentPeriodControl.value.id || !form?.valid
        "
        [class.square-btn--green]="
          currentPeriodControl && !currentPeriodControl.value.id && form?.valid
        "
        class="square-btn square-btn--right-rounded"
      >
        <img [lazyLoad]="'assets/icons/save_white.svg'" alt="icon" />
      </button>
    </div>
  </footer>
</custom-modal-card>
